<template>
    <el-drawer :title="formData && formData.id ? '编辑关键词' :'创建关键词' " :visible.sync="drawerShow" :wrapperClosable="false" :destroy-on-close="true" size="400px"
        @close="close">
            <div class="drawer-content"> 
				<el-form
				    :model="formData"				    
				    ref="formData"
				    label-position="top"
				    v-loading="dataLoading"
				>
                    <el-form-item prop="name"  :rules="[{ required: true, message: '请填写关键词名称' }]">
                        <span slot="label">关键词名称：</span>
                        <el-input v-model="formData.name" maxlength="20" show-word-limit ></el-input>
                    </el-form-item>
					<el-form-item prop="type" label="关键词类型：" :rules="[{ required: true, message: '请选择广告位' }]">
					    <el-select v-model="formData.type"  placeholder="请选择">
					        <el-option label="演出" :value="0"></el-option>
					        <el-option label="巡演" :value="1"></el-option>
					        <el-option label="活动" :value="2"></el-option>
							<el-option label="场地" :value="3"></el-option>
					        <el-option label="艺人" :value="4"></el-option>
                            <el-option label="周边" :value="5"></el-option>				
                            <el-option label="演出主题" :value="6"></el-option>	        
					    </el-select>
					</el-form-item>
					<el-form-item prop="type" label="显示位置：" :rules="[{ required: true, message: '请选择显示位置' }]">
					    <el-radio-group v-model="formData.displayPosition">
					        <el-radio :label="0">为你推荐</el-radio>
							<el-radio :label="1">搜索栏</el-radio>
					    </el-radio-group>
					</el-form-item>
					<el-form-item prop="sort" :rules="[{ required: true, message: '请填写显示权重' }]">
					    <span slot="label">显示权重：</span>
					    <el-input-number  v-model="formData.sort" style="width: 100%;"  controls-position="center" :min="1" :max="15" size="medium" placeholder="1-15数字，数字小排在前面展示"></el-input-number>
					</el-form-item>
					<el-form-item prop="targetId" :rules="[{ required: true, message: '请填写跳转目标' }]">
					    <span slot="label">跳转目标：</span>
					    <el-input v-model="formData.targetId"  :placeholder="formData.type == 2 ? '请输入活动连接'  : '请填写对应ID' "></el-input>
						<small><span class="color-warning">演出、巡演、场地、艺人、周边、演出主题填写对应ID，活动填写活动链接</span></small>
					</el-form-item>					
					<el-form-item prop="datetimerange" :rules="[{ required: true, message: '请选择展示时间' }]">
					    <span slot="label">展示时间：</span>					   
					        <el-date-picker
					            v-model="formData.datetimerange"
					            type="datetimerange"
					            start-placeholder="开始时间"
					            end-placeholder="结束时间"
					            value-format="yyyy-MM-dd HH:mm:ss"
					            size="medium"
					            unlink-panels
					        ></el-date-picker>					    
					</el-form-item>
					<el-form-item prop="settingType" :rules="[{ required: true, message: '请选择展示城市' }]" >
						<span slot="label">展示城市:</span>
					    <el-radio-group v-model="formData.settingType">
					        <el-radio :label="0">全国展示</el-radio>
					        <el-radio :label="1">只在下面地区展示</el-radio>
					    </el-radio-group>
					</el-form-item>
					<el-form-item prop="areaList" v-if="formData.settingType != 0">
					    <span slot="label">地区设置:</span>
					    <el-cascader v-model="formData.areaList" :options="cityList" filterable
					        :props="{ label: 'name', children: 'cityList', value: 'id', multiple: true, checkStrictly: true }"
					        style="width:100%" ref="cityCascader">
					    </el-cascader>						
					</el-form-item>                    
                </el-form>
            </div>
            <div class="drawer-footer">
                <el-button @click="close">关闭</el-button>
                <el-button type="primary" @click="submitForm()" :loading="btnLoading"
                >确认创建</el-button
            >
            </div>
    </el-drawer>
</template>
<script>
import { fetchAllCity } from '@/assets/js/commonApi'
const defaultFormData = {
	id:'',
	name:'',
	type:0,
	displayPosition:0,
    settingType:0,
	targetId:'',	
	cityCode:'',
	sort:'',
	datetimerange:[],
}
export default {
    data(){
        return{
            drawerShow:false,
            btnLoading:false,
            formData:{...defaultFormData},
            
           
            dataLoading: false,
			cityList: [],
			sellArea:[],
			
			data:{}
        }
    },
    methods:{
        show(data){
			this.formData = data ? {
			    ...defaultFormData,
			    ...data,
			    datetimerange:[data.startTime,data.endTime],
				settingType: data.cityCode == 0 ? 0 : 1
			} 
			: {...defaultFormData};
            this.drawerShow = true;
			this.getCityList();	
        },
        close(){
            this.formData = {...defaultFormData};           
            this.drawerShow = false;
			
        },
        
       //获取城市列表
      async getCityList(){
          const res = await fetchAllCity({}).catch(() => {});
          const{ state, result} = res.data;
          if( state == 1 ){
              this.cityList = result;
          }
      },
	  
        //表单提交
        submitForm(){
            this.$refs["formData"].validate( async (valid) => {
                if(valid){
					
                    if( this.formData.settingType != 0 && this.formData.areaList.length == 0 ){
                    	this.$message.warning('城市不能为空');
                    	return					
                    }
					if( this.formData.settingType == 1 ){
						this.formData.provinceCode = [];
						this.formData.cityCode = [];
						this.formData.areaList.map(item => {
							if (!this.formData.provinceCode.find(v => v == item[0]) && !item[1]) {
								this.formData.provinceCode.push(item[0]);
							}
							item[1] && this.formData.cityCode.push(item[1]);
						})
						
					}
                    this.btnLoading = true;
                    this.$request({
                        url: "/search/recommend/save",
                        method: "POST",
                        data: {
                            ...this.formData,
							startTime: this.formData.datetimerange[0],
							endTime: this.formData.datetimerange[1],
							cityCode: this.formData.settingType == 1 ? this.formData.cityCode.toString() : 0,
							provinceCode: this.formData.settingType == 1 ? this.formData.provinceCode.toString() : 0
                        },
                    })
                    .then((res) => {
                        const { state, msg } = res.data;
                        if ( state == 1) {
                            this.$emit('onUpdate');
                            this.close();
                        } else {
                            this.$message.error(msg || "请求失败");
                        }
                    })
                    .catch(() => {
                        this.$message.error("请求错误");
                    })
                    .finally(() => {
                        this.btnLoading = false;
                    });
                }else{
                    return false;
                }
            })
        }
    }
}
</script>
<style lang="scss" scoped>

</style>